import {
    AdvancedSettingsPanel,
    MakeAllowUnsecuredAccessToggle,
    LimitedAdvancedSettings,
} from 'apps/studio/components/settings/fields/Base/advanced'
import { SettingsLabel } from 'apps/studio/components/shared/inputs/SettingsLabel'

const AttachFileToggle = {
    label: 'Attach File Directly to Email',
    labelLarge: true,
    settingType: 'toggleInput',
    property: 'style',
    choices: [
        { value: 1, previousValue: 0 },
        { value: 0, previousValue: 1 },
    ],
    tooltipContent: <>
        {`Emails are limited to 25MB. If the total email size exceeds this limit, the attachment will be available as a link in your submission.`}
    </>
}

export const AdvancedPanel = AdvancedSettingsPanel([
    SettingsLabel('Config'),
    MakeAllowUnsecuredAccessToggle('an attachment'),
    AttachFileToggle,
    ...LimitedAdvancedSettings,
])
